import { useId } from "react";
import type { SourceScheduleInput, SourceScheduleWeekday } from "../../../../shared/types";
import { Input } from "./Input";

const weekdays: SourceScheduleWeekday[] = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const selectClass = "w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:bg-slate-50";

/** Controlled calendar fields; persistence, action identity and On/Off belong to the caller. */
export function ScheduleFields({ value, onChange, disabled = false, allowedFrequencies = ["daily", "weekly"] }: {
  value: SourceScheduleInput; onChange: (value: SourceScheduleInput) => void; disabled?: boolean;
  /** Hide frequencies the caller's backend cannot execute. Existing callers offer both. */
  allowedFrequencies?: readonly SourceScheduleInput["frequency"][];
}) {
  const id = useId();
  return <fieldset disabled={disabled} className="grid min-w-0 gap-3 sm:grid-cols-2">
    <legend className="sr-only">Schedule timing</legend>
    <label className="flex flex-col gap-1.5 text-sm font-medium text-slate-700">Frequency
      <select className={selectClass} value={value.frequency} onChange={event => onChange(event.target.value === "weekly"
        ? { frequency: "weekly", weekday: "monday", time: value.time, timezone: value.timezone }
        : { frequency: "daily", time: value.time, timezone: value.timezone })}>
        {allowedFrequencies.includes("daily") && <option value="daily">Daily</option>}{allowedFrequencies.includes("weekly") && <option value="weekly">Weekly</option>}
      </select>
    </label>
    {value.frequency === "weekly" && <label className="flex flex-col gap-1.5 text-sm font-medium text-slate-700">Weekday
      <select className={selectClass} value={value.weekday} onChange={event => onChange({ ...value, weekday: event.target.value as SourceScheduleWeekday })}>
        {weekdays.map(day => <option key={day} value={day}>{day[0]!.toUpperCase() + day.slice(1)}</option>)}
      </select>
    </label>}
    <Input id={`${id}-time`} label="Local time" type="time" required step={60} value={value.time} onInput={event => onChange({ ...value, time: event.currentTarget.value })} />
    <Input id={`${id}-timezone`} label="Timezone (IANA)" required placeholder="America/Chicago" value={value.timezone} onInput={event => onChange({ ...value, timezone: event.currentTarget.value })} />
  </fieldset>;
}
